import { PagesModule } from 'pages/pages.module';
import { NgModule } from '@angular/core';
import { ComponentsModule } from 'components/components.module';
import { AdminUserPermissionsPage } from 'pages/admin-user-permissions/admin-user-permissions';

@NgModule({
    declarations: [AdminUserPermissionsPage],
    imports: [PagesModule, ComponentsModule]
})
export class AdminUserPermissionsPageModule { }
